// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__fzjjV","upload":"Small_upload__2O97f","imageWrap":"Small_imageWrap__3RhdX","removeBtn":"Small_removeBtn__3C2zz"};